import { APICfg } from 'services/api/api'
import { baseProductParse, baseProductWrite } from '.'

const apiCfg: APICfg = {
  endpoint: 'rent',
  parse: baseProductParse,
  write: baseProductWrite,
}

export default apiCfg
